import type { SiteSectionsTreeSectionCategoryFilterVariant } from "@/app/tools/new-section-management/site-sections-tree/filters/section-category-filter/site-sections-tree-section-category-filter.types";
import type { MultiSelectPassThroughOptions } from "primevue/multiselect";
import type { SelectPassThroughOptions } from "primevue/select";

import { cn } from "@voltalis/frontend-utils";

import { DATA_TEST_IDS } from "@/constants/data-test-ids/data-test-ids.constant";

export function createMultiSelectPassThroughOptions(
  isCategoryCreationFormVisible: boolean,
): MultiSelectPassThroughOptions {
  return {
    overlay: {
      "data-test-id": DATA_TEST_IDS.components.siteSectionsTreeSectionCategoryFilter.popover,
    },
    pcFilter: {
      root: {
        "data-test-id": DATA_TEST_IDS.components.siteSectionsTreeSectionCategoryFilter.searchInput,
      },
    },
    listContainer: {
      class: cn({
        "pointer-events-none opacity-40": isCategoryCreationFormVisible,
      }),
    },
  };
}

export function createSingleSelectPassThroughOptions(
  variant: SiteSectionsTreeSectionCategoryFilterVariant,
): SelectPassThroughOptions {
  const isInversePillVariant = variant === "inverse-pill";

  return {
    overlay: {
      "data-test-id": DATA_TEST_IDS.components.siteSectionsTreeSectionCategoryFilter.popover,
      class: cn({
        "site-sections-tree-section-category-filter-overlay--inverse-pill !min-w-0 !rounded !border-0 !bg-white !p-3 !shadow-[0_4px_6px_rgba(0,0,0,0.1)]":
          isInversePillVariant,
      }),
    },
    header: {
      class: cn({
        "!p-0 !pb-2": isInversePillVariant,
      }),
    },
    pcFilter: {
      root: {
        "data-test-id": DATA_TEST_IDS.components.siteSectionsTreeSectionCategoryFilter.searchInput,
        class: cn({
          "!min-h-10 !rounded-lg !border-neutral-light !py-2.5 !pl-10 !pr-3 !text-sm !font-normal !leading-normal !text-secondary placeholder:!text-secondary":
            isInversePillVariant,
        }),
      },
    },
    pcFilterIconContainer: {
      root: {
        class: cn({
          "!left-3.5 !right-auto !size-[18px] !text-secondary": isInversePillVariant,
        }),
      },
    },
    filterIcon: {
      class: cn({
        "!size-[18px] !text-secondary": isInversePillVariant,
      }),
    },
    listContainer: {
      class: cn({
        "!max-h-none": isInversePillVariant,
      }),
    },
    list: {
      class: cn({
        "!flex !flex-col !gap-1 !p-0": isInversePillVariant,
      }),
    },
    option: {
      class: cn({
        "!rounded-lg !p-2 data-[p-selected=true]:!bg-option-selected": isInversePillVariant,
      }),
    },
  };
}
